import { Box, Colors } from '@helloself/hello-self-ui';
import { useParams } from 'react-router-dom';

import { ErrorProfile } from '../components/ErrorProfile';
import ExpertProfile from '../components/ExpertProfile';
import { NoProfileFound } from '../components/NoProfileFound';
import PartnerProfile from '../components/PartnerProfile';
import expertBackgroundImage from '../images/expertBackground.svg';
import { useGetFullProfileByExpertIdQuery } from '../model/profile';
import { FullProfile } from '../model/types';

export interface ProfileProps {
    profile?: FullProfile;
    isLoadingProfiles: boolean;
    background?: {
        backgroundImage: string;
        backgroundPosition: string;
    };
}

export default function ProfilePageRoute() {
    const expertBackground = {
        backgroundImage: `url(${expertBackgroundImage}), linear-gradient(136deg, #E4F1F9 0%, ${Colors.purple10} 100%)`,
        backgroundPosition: '0 34px, 0 0',
    };
    const { cognitoId: expertId } = useParams<{ cognitoId: string }>();

    // profile data
    const {
        data: profile,
        isLoading: isLoadingProfile,
        error: errorLoadingProfile,
    } = useGetFullProfileByExpertIdQuery(expertId, { skip: !expertId });
    const userType = profile?.userType;
    const backgroundImage = userType === 'expert' ? expertBackground : undefined;
    if (errorLoadingProfile) {
        return <ErrorProfile background={backgroundImage} />;
    }
    if (!profile && !isLoadingProfile) {
        return <NoProfileFound previewBackground={backgroundImage} />;
    }

    return (
        <Box height="100%">
            {userType === 'expert' ? (
                <ExpertProfile profile={profile} isLoadingProfiles={isLoadingProfile} background={expertBackground} />
            ) : (
                <PartnerProfile profile={profile} isLoadingProfiles={isLoadingProfile} />
            )}
        </Box>
    );
}
